import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "panel"
}
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = /*#__PURE__*/_createVNode("label", {
  for: "company",
  class: "form-label"
}, "Company", -1)
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", {
  for: "username",
  class: "form-label"
}, "Username", -1)
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = {
  for: "password",
  class: "form-label"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" - confirm - ")
const _hoisted_10 = /*#__PURE__*/_createVNode("div", {
  id: "passwordHelp",
  class: "form-text"
}, [
  /*#__PURE__*/_createTextVNode("10+ characters, with at least one uppercase (A, B, ...) , one lowercase (a, b, ...), a number (0, 1, ...), and, a symbol ($, !, ...). Something like "),
  /*#__PURE__*/_createVNode("span", { class: "mark" }, "Today is day 1!"),
  /*#__PURE__*/_createTextVNode(" would do.")
], -1)
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", {
  for: "email",
  class: "form-label"
}, "Email", -1)
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", {
  for: "name",
  class: "form-label"
}, "Name", -1)
const _hoisted_15 = { class: "mb-3" }
const _hoisted_16 = /*#__PURE__*/_createVNode("label", {
  for: "displayname",
  class: "form-label"
}, "Display Name", -1)
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = /*#__PURE__*/_createVNode("label", {
  for: "phone",
  class: "form-label"
}, "Phone", -1)
const _hoisted_19 = { class: "mb-3" }
const _hoisted_20 = /*#__PURE__*/_createVNode("label", {
  for: "status",
  class: "form-label"
}, "Status", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("option", { value: "active" }, "Enabled", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("option", { value: "inactive" }, "Disabled", -1)
const _hoisted_23 = { class: "mb-3" }
const _hoisted_24 = /*#__PURE__*/_createVNode("h5", null, "Permissions", -1)
const _hoisted_25 = {
  type: "submit",
  id: "save",
  class: "btn btn-primary"
}
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error_block = _resolveComponent("error-block")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h1", null, _toDisplayString(_ctx.msg), 1),
    _createVNode(_component_error_block, { errors: _ctx.errors }, null, 8, ["errors"]),
    (_ctx.user.id)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("fieldset", null, [
            _createVNode("form", {
              id: 'user_' + _ctx.user.id,
              onSubmit: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.callSave()), ["prevent"]))
            }, [
              _createVNode("div", _hoisted_3, [
                _hoisted_4,
                _withDirectives(_createVNode("select", {
                  class: "form-control",
                  id: "company",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.user.Company.id = $event)),
                  disabled: ""
                }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.companyList.items, (value, idx) => {
                    return (_openBlock(), _createBlock("option", {
                      key: idx,
                      value: value.id
                    }, _toDisplayString(value.DisplayName), 9, ["value"]))
                  }), 128))
                ], 512), [
                  [
                    _vModelSelect,
                    _ctx.user.Company.id,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createVNode("div", _hoisted_5, [
                _hoisted_6,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "username",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.user.Username = $event))
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.user.Username,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createVNode("div", _hoisted_7, [
                _createVNode("label", _hoisted_8, _toDisplayString(_ctx.user.id == ':' ? 'Set' : 'Change') + " Password", 1),
                _withDirectives(_createVNode("input", {
                  type: "password",
                  autocomplete: "off",
                  class: "form-control",
                  id: "password",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.user.Password = $event))
                }, null, 512), [
                  [_vModelText, _ctx.user.Password]
                ]),
                _hoisted_9,
                _withDirectives(_createVNode("input", {
                  type: "password",
                  autocomplete: "off",
                  class: "form-control",
                  id: "newpassword",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.user.NewPassword = $event))
                }, null, 512), [
                  [_vModelText, _ctx.user.NewPassword]
                ]),
                _hoisted_10
              ]),
              _createVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "email",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.user.Email = $event))
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.user.Email,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createVNode("div", _hoisted_13, [
                _hoisted_14,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "name",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.user.Name = $event))
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.user.Name,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createVNode("div", _hoisted_15, [
                _hoisted_16,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "displayname",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.user.DisplayName = $event))
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.user.DisplayName,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createVNode("div", _hoisted_17, [
                _hoisted_18,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "phone",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.user.Phone = $event))
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.user.Phone,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createVNode("div", _hoisted_19, [
                _hoisted_20,
                _withDirectives(_createVNode("select", {
                  class: "form-control",
                  id: "status",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.user.Status = $event)),
                  disabled: _ctx.user.id == this.$store.getters.getUserId
                }, [
                  _hoisted_21,
                  _hoisted_22
                ], 8, ["disabled"]), [
                  [_vModelSelect, _ctx.user.Status]
                ])
              ]),
              _createVNode("div", _hoisted_23, [
                _hoisted_24,
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.authorityList.items, (value, idx) => {
                  return (_openBlock(), _createBlock("div", {
                    key: idx,
                    class: "form-check"
                  }, [
                    _withDirectives(_createVNode("input", {
                      type: "checkbox",
                      "aria-describedby": 'authority-'+idx,
                      class: "form-check-input",
                      id: 'authority-'+idx+'-sel',
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.user.Authority = $event)),
                      value: value
                    }, null, 8, ["aria-describedby", "id", "value"]), [
                      [_vModelCheckbox, _ctx.user.Authority]
                    ]),
                    _createVNode("span", {
                      class: "form-check-label sm-3",
                      id: 'authority-'+idx,
                      style: {"min-width":"8em"}
                    }, _toDisplayString(value), 9, ["id"])
                  ]))
                }), 128))
              ]),
              _createVNode("button", _hoisted_25, _toDisplayString(_ctx.user.id == ':' ? 'create' : 'save'), 1),
              _hoisted_26,
              (_ctx.user.id != ':' && _ctx.user.id != this.$store.getters.getUserId)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    class: "btn btn-outline-danger",
                    onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.callDelete()), ["prevent"]))
                  }, "delete"))
                : _createCommentVNode("", true)
            ], 40, ["id"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}